$(".one-time").slick({
  centerMode: false,
  arrows: false,
  centerPadding: "60px",
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        dots: true,
        centerPadding: "40px",
        slidesToShow: 1,
      },
    },
  ],
});
